import awards from "../../shared/pt.awards";
import branded_quotes from "../../shared/pt.branded-quotes";
import verticals from "./pt-consumer-seo.verticals";

const pageFooter = ({ strings }) => {
    return {
        awards: {
            visible: true,
            title: {
                content: strings.awards_header_label,
                align: "center",
                type: "section-title"
            },
            panels: awards({ strings })
        },
        branded_quotes: {
            visible: true,
            title: {
                content: strings.branded_quotes_header_label,
                align: "center",
                type: "section-title"
            },
            panels: branded_quotes({ strings })
        },
        verticals: {
            visible: true,
            title: {
                content: strings.verticals_label,
                align: "center",
                type: "section-title"
            },
            panels: verticals({ strings })
        }
    };
};

export default ({ page, strings }) => {
    switch (page) {
        case "pt-enterprise-404":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    trustpilot: true,
                    lang: "en"
                },
                awards: {
                    panels: awards({ strings }),
                    title: {
                        align: "center",
                        content: strings.awards_header_label,
                        theme: "black",
                        type: "section-title"
                    },
                    visible: true
                },
                branded_quotes: {
                    title: {
                        align: "center",
                        content: strings.branded_quotes_header_label,
                        theme: "black",
                        type: "section-title"
                    },
                    panels: branded_quotes({ strings }),
                    visible: true
                },
                verticals: {
                    title: {
                        align: "center",
                        content: null,
                        theme: "black",
                        type: "section-title"
                    },
                    panels: verticals({ strings }),
                    visible: false
                }
            };
        case "pt-consumer-seo-basic":
            return {
                page,
                helmet: {
                    meta_title: "Página não encontrada | Rosetta Stone",
                    meta_description: "",
                    canonical_url: "https://pt.rosettastone.com/404",
                    lang: "pt"
                },
                ...pageFooter({ strings })
            };
        default:
            return null;
    }
};
